import { useQuery } from "react-query";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { toast } from "react-hot-toast";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";

export const useGetContaPrincipalByCondominio = (condominioId: number | null) => {
  const onError = () => {
    toast.error("Erro ao buscar conta principal do condomínio");
  };

  return useQuery<Cond21CloudResponse<any>>({
    queryKey: ["conta-principal-condominio", condominioId],

    queryFn: async () => {
      const response = await http.get<Cond21CloudResponse<any>>(
        `${api.conta.getContaPrincipalByCondominio}/${condominioId}`
      );
      return response.data;
    },
    enabled: condominioId != null,
    onError,
  });
};
